export const capitalizeFirstLetter = (str: string, isNotMakeLowerCase?: boolean) => {
  if (!str) {
    return '';
  }
  const allParts = str.slice(1);
  return str.charAt(0).toUpperCase() + (isNotMakeLowerCase ? allParts : allParts.toLowerCase());
};

export const capitalizeWords = (str: string): string => {
  return str.replace(/(?:^|[ &])\S/g, match => match.toUpperCase());
};

export const normalizeSearchQuery = (query?: string): string => query?.trim() ?? '';
